module.exports = __webpack_public_path__ + "img/caret-right-square-fill.6011fff5.svg";